// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2VosX","dragIcon":"SortableItem_dragIcon__20_aa","disabled":"SortableItem_disabled__39USZ"};